// extracted by mini-css-extract-plugin
export default {"card":"SimpleAppointmentCard_card__n4PJG","item":"SimpleAppointmentCard_item__-pCUR","text-icon":"SimpleAppointmentCard_text-icon__50cKe"};